/**
 * Interceptor Registry
 *
 * Central registry of all question interceptors. Add new interceptors here
 * to enable custom flows for specific questionnaire questions.
 */

import { QuestionInterceptor } from './types';
import { LabsOrderInterceptor } from './labs-order-interceptor';

export const INTERCEPTOR_REGISTRY: QuestionInterceptor[] = [
  {
    questionSlug: 'labs_order_status',
    // Always intercept - the component will handle all state logic
    shouldIntercept: () => true,
    component: LabsOrderInterceptor,
  },
];
